import React from 'react';
import './style.scss';
import clsx from 'clsx';
import { RichText, useSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { cardsCompareFeatureTypes } from '../../../../../utils';
import { CheckIcon, CrossIcon } from '../../../../icons';

const CardsCompareTableFeatureLine = ({ featureList, hidden }) => (
  <tr className={clsx('cct-row', hidden && 'cct-row-hidden')}>
    <td>
      <div className="cct-td-content cct-th-content">{featureList.title}</div>
    </td>
    {featureList.values.map((featureValue, index) => (
      <td key={`value${index}`}>
        <Content data={featureValue} />
      </td>
    ))}
  </tr>
);

const Content = ({ data }) => {
  const context = useSitecoreContext();
  const currency = context?.sitecoreContext?.siteConfigurations?.currency || 'AED';

  switch (data.valueType) {
    case cardsCompareFeatureTypes.notExisting: {
      return <div className={clsx('cct-td-content', 'cct-td-content-na')}>N/A</div>;
    }
    case cardsCompareFeatureTypes.boolean: {
      return <div className="cct-td-content">{data.value ? <CheckIcon /> : <CrossIcon />}</div>;
    }
    case cardsCompareFeatureTypes.currency: {
      return (
        <div className="cct-td-content">
          <span className="cct-td-content-light">{currency}</span>&nbsp;{data.value}
        </div>
      );
    }
    case cardsCompareFeatureTypes.html: {
      return (
        <div className={clsx('cct-td-content', 'cct-td-content-plain')}>
          <RichText field={{ value: data.value }} />
        </div>
      );
    }
    default: {
      return <div className="cct-td-content">{data.value}</div>;
    }
  }
};

export default CardsCompareTableFeatureLine;
